import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import {useHistory} from "react-router-dom";
import './style.css';


class CustomButton extends Component {

    
    // HandleClick = () => {
    //     const history = useHistory();
    //     history.push("/home");
    // }
    render() {
        return (
            
            <div className="button" style={this.props.style} id={this.props.id} onClick={this.props.onClick}>
                <p>{this.props.text}</p>
            </div>
        )
    }
}

export default CustomButton
